// 📁 src/components/BlogList.jsx
import { useEffect, useState } from "react";
import { loadZens } from "../data/loadZens";
import ZenCard from "./ZenCard";
import { motion, AnimatePresence } from "framer-motion";
import { PaperDarkBG } from "../kits";

export default function ZenList() {
  const [zens, setZens] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadZens().then((data) => {
      setZens(data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="p-6 max-w-6xl py-10 mx-auto">
   
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 auto-rows-fr ">
        <AnimatePresence>
          {loading
            ? Array.from({ length: 6 }).map((_, i) => (
                <motion.div
                  key={i}
                  className="bg-gray-100 h-64 rounded-sm sm:rounded-md animate-pulse flex items-center justify-center text-gray-500 text-sm"
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  <span className="text-xs font-mono">Gleich geht`s los ...</span>
                </motion.div>
              ))
            : zens.map((zen) => (
                <motion.div
                  key={zen.slug} className="h-full"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  <ZenCard zen={zen} />
                </motion.div>
              ))}
        </AnimatePresence>
      </div>
    </div>
  );
}
